export default class HeaderController {
    /** @ngInject */
    constructor($state, $mdPanel) {
        this.$state = $state;
        this.$mdPanel = $mdPanel;
    }

    $onInit() {
        this.isMobileNav = false;
    }

    showNotifications() {
        this.$state.go('main.notifications');
    }

    showUserInfo(ev) {
        const position = this.$mdPanel.newPanelPosition()
            .relativeTo(ev.target)
            .addPanelPosition(this.$mdPanel.xPosition.ALIGN_END, this.$mdPanel.yPosition.BELOW);

        const config = {
            attachTo: document.body,
            controller: () => {},
            controllerAs: '$ctrl',
            template: '<dt-user-popover on-close="$ctrl.closeUserInfo()"></dt-user-popover>',
            panelClass: 'md-panel--arrow-top',
            position,
            openFrom: ev,
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: false,
            zIndex: 100,
            locals: {
                closeUserInfo: this.closeUserInfo
            }
        };

        this.$mdPanel.open(config);
    }

    closeUserInfo() {
        this.mdPanelRef.close();
    }
}



// WEBPACK FOOTER //
// ./app/common/header/header.controller.js